<template>
	<div class="footer" :class="isPhone == 'true' ? 'mobile' : ''">
		<div class="bottom_container">
			<div class="bottom_content">
				<div class="bottom_list">
					<h6>
						格式转换
						<span class="icon_free" style="width: 80px">限时免费</span>
					</h6>
					<div class="turn_list">
						<ul>
							<li @click="jumpPage('/domConversionOfd/?type=ofdtopdf',2)">
								<img src="@comm/images/document-conversion/homeSVG/ofd_to_pdf.svg" class="img" alt />
								<img src="@comm/images/document-conversion/homeSVG/ofd_to_pdf_hover.png"
									class="img_hover" alt />
								OFD转PDF
							</li>
							<li @click="jumpPage('/domConversionOfd/?type=toofd',2)">
								<img src="@comm/images/document-conversion/homeSVG/excel_to_ofd.svg" class="img" alt />
								<img src="@comm/images/document-conversion/homeSVG/excel_to_ofd_hover.svg"
									class="img_hover" alt />
								Excel转OFD
							</li>
							<li @click="jumpPage('/domConversionOfd/?type=toofd',2)">
								<img src="@comm/images/document-conversion/homeSVG/word_to_ofd.svg" class="img" alt />
								<img src="@comm/images/document-conversion/homeSVG/word_to_ofd_hover.svg"
									class="img_hover" alt />
								Word转OFD
							</li>
							<li @click="jumpPage('/domConversionOfd/?type=toofd',2)">
								<img src="@comm/images/document-conversion/homeSVG/ppt_to_ofd.svg" class="img" alt />
								<img src="@comm/images/document-conversion/homeSVG/ppt_to_ofd_hover.svg"
									class="img_hover" alt />
								PPT转OFD
							</li>
							<li @click="jumpPage('/imgConversion/?type=toofd',2)">
								<img src="@comm/images/document-conversion/homeSVG/img_to_ofd.svg" class="img" alt />
								<img src="@comm/images/document-conversion/homeSVG/img_to_ofd_hover.svg"
									class="img_hover" alt />
								图片转OFD/PDF
							</li>
							<li @click="jumpPage('/imgConversion/?type=toimg',2)">
								<img src="@comm/images/document-conversion/homeSVG/ofd_to_img.svg" class="img" alt />
								<img src="@comm/images/document-conversion/homeSVG/ofd_to_img_hover.svg"
									class="img_hover" alt />
								OFD/PDF转图片
							</li>
							<li @click="jumpPage('/domConversionOfd/?type=toofd',2)">
								<img src="@comm/images/document-conversion/homeSVG/other_to_ofd.png" class="img" alt />
								<img src="@comm/images/document-conversion/homeSVG/other_to_ofd_hover.png"
									class="img_hover" alt />
								其他转OFD
							</li>
							<li @click="jumpPage('/domConversionOfd/?type=topdf',2)">
								<img src="@comm/images/document-conversion/homeSVG/other_to_pdf.svg" class="img" alt />
								<img src="@comm/images/document-conversion/homeSVG/other_to_pdf_hover.png"
									class="img_hover" alt />
								其他转PDF
							</li>
						</ul>
					</div>
				</div>
				<div class="bottom_list">
					<h6>行业应用<span class="icon_free">免费</span></h6>
					<ul>
						<li @click="jumpPage('/InApplication/',1)">
							<img src="@comm/images/document-conversion/homeSVG/svg_fapiao.svg" class="img" alt />
							<img src="@comm/images/document-conversion/homeSVG/svg_fapiao_hover.svg" class="img_hover"
								alt />
							电子发票
						</li>
						<li @click="jumpPage('/electronicCertificate',1)">
							<img src="@comm/images/document-conversion/electronicDocuments/bottom_icon.png" class="img"
								alt />
							<img src="@comm/images/document-conversion/electronicDocuments/bottom_icon_active.png"
								class="img_hover" alt />
							电子凭证

						</li>
					</ul>
					<!-- 文档预览 -->
					<div class="read_page">
						<h6>文档预览</h6>
						<ul>
							<li @click="jumpPage('/onlinePreview/')">
								<img src="@comm/images/document-conversion/homeSVG/svg_read.svg" class="img" alt />
								<img src="@comm/images/document-conversion/homeSVG/svg_read_hover.png" class="img_hover"
									alt />
								在线预览
							</li>
						</ul>
					</div>
					<div class="read_page">
						<h6>批量验证</h6>
						<ul>
							<li @click="jumpPage('/attestationPage')">
								<img src="@comm/images/document-conversion/homeSVG/yq_icon.png" class="img" alt />
								<img src="@comm/images/document-conversion/homeSVG/yq_icon_active.png" class="img_hover"
									alt />
								在线验签
							</li>
						</ul>
					</div>
				</div>
				<div class="bottom_list lianxi">
					<h6>联系我们</h6>
					<ul>
						<li>
							<img src="@comm/images/document-conversion/icon_tel_footer.svg" class="img" alt />
							<div class="right">
								<h4>400-677-5005</h4>
								<h5>拨通电话，我们会给您满意的答复</h5>
							</div>
						</li>
						<li>
							<img src="@comm/images/document-conversion/icon_mail_footer.svg" class="img" alt />
							<div class="right">
								<h4 class="color">
									<a href="http://www.suwell.cn/" target="_blank">www.suwell.cn</a>
								</h4>
								<h5>更多信息请登录官方网站</h5>
							</div>
						</li>
						<li>
							<img src="@comm/images/document-conversion/icon_qq_footer.svg" class="img" alt />
							<div class="right">
								<h4>946014825</h4>
								<h5 @click="joinBtn" class="color">加入数科OFD交流群</h5>
							</div>
						</li>
					</ul>
					<div class="read_page">
						<h6>平台服务</h6>
						<ul>
							<li @click="jumpPage('https://satl.ofd.cn',6,true)">
								<img src="@comm/images/document-conversion/notice/satl-foot_active.svg" class="img"
									alt />
								<img src="@comm/images/document-conversion/notice/satl_foot.svg" class="img_hover"
									alt />
								SATL计划
							</li>
							<!-- <li @click="jumpPage('https://open.ofd.cn', 6, true)">
								<img src="@comm/images/document-conversion/notice/open_foot.svg" class="img" alt />
								<img src="@comm/images/document-conversion/notice/open_active.svg" class="img_hover"
									alt />
								开放平台
							</li> -->
						</ul>
					</div>
				</div>
				<div class="bottom_list">
					<h6>关注我们</h6>
					<div class="box">
						<div class="list">
							<img src="@comm/images/document-conversion/home/bottom_erweima.png" alt class="erweima" />
							<h4>关注OFD云公众号</h4>
						</div>
						<div class="list">
							<img src="@comm/images/document-conversion/home/erweima.png" alt class="erweima" />
							<h4>关注数科网维公众号</h4>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="copyright" v-html="copyright"></div>
	</div>
</template>

<script>
import { copyText } from '@comm/utils/tools'
export default {
	name: "footerPage",
	data() {
		return {
			isPhone: false,
			path: "",
			copyright: "",
			APIPort: process.env.APIPort
		};
	},
	created() {
		this.path = this.$route.path;
		this.isPhone = localStorage.getItem("isPhone");
		this.info = JSON.parse(localStorage.getItem("info"));
		const year = new Date().getFullYear();
		this.copyright =
			`<p>Copyright © 2006-${year} Suwell. All Rights Reserved. 数科网维公司 版权所有<span style='display:inline-block;width:16px'></span><a style='color: #fff;' href='https://beian.miit.gov.cn/#/Integrated/index' target='_blank'>京ICP备16014466号-2</a></p>`;
	}, 
	methods: {
		joinBtn() {
			window.open("https://jq.qq.com/?_wv=1027&k=buqIcKXH");
		},
		//复制
		copyBtn(data) {
			copyText(data)
			// let oInput = document.createElement("input");
			// oInput.value = data;
			// document.body.appendChild(oInput);
			// oInput.select(); // 选择对象;
			// document.execCommand("Copy"); // 执行浏览器复制命令
			// this.$message({
			// 	message: "复制成功",
			// 	type: "success"
			// });
			// document.body.removeChild(oInput);
		},
		jumpPage(path, type, target) {
			let page = `${this.$route.path}?type=${this.$route.query.type}`
			localStorage.setItem('index', type)
			if (target) {
				window.open(path, "_blank");
			 }else if (path === page) {
				this.$router.go(0);
			}else if (this.$route.path == path) {
				let toElement = document.getElementById('top');
				toElement.scrollIntoView();
			}else {
				this.$router.push({ path: path });
			}
		}
	}
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.footer {
	position: relative;
	.bj {
		position: absolute;
		left: 0;
		top: -132px;
		width: 100%;
	}
	.bg-des {
		position: absolute;
		left: -81px;
		top: -256px;
		width: 550px;
		pointer-events: none;
	}
}
.title {
	height: 43px;
	font-size: 28px;
	color: #242f44;
	line-height: 38px;
	text-align: center;
	margin-top: 4.6%;
}
/*实时为您服务*/
.bottom_service {
	padding-top: 18px;
	width: 100%;
	margin: 0 auto 88px;

	.bottom_lx {
		display: flex;
		flex-direction: row;
		align-items: center;

		.bottom {
			width: 264px;
			height: 218px;
			margin-right: 48px;
			text-align: center;
			padding-top: 40px;

			&:last-child {
				margin-right: 0;
			}

			img {
				width: 48px;
				margin-bottom: 30px;

				&.erweima {
					width: 86px;
					height: 86px;
				}
			}

			.fonts {
				font-size: 16px;
				color: #242f44;

				p {
					line-height: 22px;
					margin: 0;
					padding-bottom: 16px;
				}
			}

			.copy_btn {
				padding-top: 16px;

				a {
					font-size: 16px;
					color: #14a8f0;
					line-height: 22px;
					cursor: pointer;
					text-decoration: underline;

					&:first-child {
						padding-right: 32px;
					}
					&:focus,
					&:active {
						color: #1299d9;
					}
				}
			}
		}
	}
}
.copyright {
	height: 48px;
	font-size: 12px;
	color: #ffffff;
	line-height: 48px;
	text-align: center;
	background: #14a8f0;
	& >>> p {
		margin: 0;
		a,
		a:hover,
		a:focus {
			color: #ffffff;
			text-decoration: none;
		}
	}
}
/*格式转换，行业应用*/
.bottom_container {
	width: 100%;
	background: url("../../images/document-conversion/bottom_bj.png") 0 0
		no-repeat;
	background-size: cover;
	padding: 41px 0;

	.bottom_content {
		max-width: 1200px;
		margin: 0 auto;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
	}

	.bottom_list {
		// margin-bottom: 64px;

		  &:nth-child(1) {
      width: 248px;
    }
    &:nth-child(2) {
      width: 224px;
    }
    &:nth-child(3) {
      width: 251px;
    }
    &:nth-child(4) {
      width: 331px;
    }
		.turn_list {
			display: flex;
			align-items: flex-start;
			justify-content: space-between;
		}
		.box{
			display: flex;
			flex-direction: row;
			align-items: center;
			.list:nth-child(2){
				margin-left: 24px;
			}
		}
		.erweima {
			width: 152px;
			height: 152px;
			display: block;
			margin: 16px auto 8px;
		}
		h4 {
			font-size: 14px;
			font-weight: 400;
			color: #242f44;
			line-height: 22px;
			text-align: center;
		}
		&.lianxi {
			&>ul li {
				font-weight: 400;
				color: #242f44;
				line-height: 24px;
				align-items: center;
				text-align: left;
				margin-top: 5px;
				&:nth-child(1) {
					margin-top: 16px;
				}
				&:hover {
					cursor: auto;
					color: #242f44;
					img {
						display: block;
					}
				}
				h4 {
					text-align: left;
					font-size: 14px;
					line-height: 24px;
					margin: 0;
				}
				h5 {
					font-size: 14px;
					line-height: 24px;
					margin: 0;
				}
				.color {
					color: #14a8f0;
					text-decoration: underline;
					cursor: pointer;
					a,
					a:hover {
						color: #14a8f0;
					}
				}
			}
			.read_page{
				margin-top: 16px;
			}
		}
		.bottom_row {
			display: flex;
			flex-direction: column;

			a {
				//color: #36425a;
				color: #14a8f0;
				text-decoration: underline;

				&:focus,
				&:active {
					color: #1299d9;
				}
				/*&:hover{
            color: #14A8F0;
            text-decoration: underline;
          }*/
			}
		}

		.bottom_lx {
			display: flex;
			flex-direction: row;
			align-items: top;
			justify-content: space-between;
		}

		.footer_zhanwei {
			color: transparent;
			width: 173px;
		}

		h6 {
			font-size: 20px;
			color: #36425a;
			line-height: 38px;
			padding-bottom: 15px;
			border-bottom: 1px #979797 dashed;
			margin: 0;
		}

		ul {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			margin: 0;

			li {
				font-size: 14px;
				color: #36425a;
				line-height: 22px;
				display: flex;
				align-items: center;
				margin-top: 16px;
				img {
					width: 24px;
					height: 24px;
					margin-right: 12px;
					display: none;
					&.img {
						display: block;
					}
				}
				&:hover {
					cursor: pointer;
					color: #363a3b;
					.img,
					.img_active {
						display: none;
					}
					.img_hover {
						display: block;
					}
				}
				&:hover {
					color: #15b2ff;
				}
			}
		}

		.bottom {
			margin-bottom: 20px;

			img {
				margin-right: 24px;
			}

			.fonts {
				display: inline-block;
				vertical-align: top;

				h4,
				h5,
				a {
					margin-bottom: 8px;
					font-size: 16px;
					color: #36425a;
					line-height: 22px;
				}

				h4 {
					span {
						padding-left: 15px;
					}
				}

				h5,
				a {
					margin-bottom: 0;
				}

				a:hover {
					color: #15b2ff;
				}

				a:focus,
				a:active {
					color: #1299d9;
				}

				p {
					font-size: 14px;
					color: #36425a;
					line-height: 22px;
				}

				.copy_btn {
					width: 126px;
					height: 40px;
					background: #ffffff;
					border-radius: 2px;
					border: 1px solid #d7d9de;
					font-size: 14px;
					color: #36425a;
					line-height: 40px;
					text-align: center;

					&:hover {
						cursor: pointer;
						border: 1px solid #15b2ff;
						color: #15b2ff;
					}
				}
			}
		}

		.left {
			img {
				width: 74px;
			}
		}
	}

	.read_page {
		margin-top: 25px;
	}
}
</style>



// WEBPACK FOOTER //
// src/comm/components/document-conversion/footerPage.vue